import { render, staticRenderFns } from "./TagNode.vue?vue&type=template&id=31d275b9&scoped=true&lang=pug"
import script from "./TagNode.vue?vue&type=script&lang=js"
export * from "./TagNode.vue?vue&type=script&lang=js"
import style0 from "./TagNode.vue?vue&type=style&index=0&id=31d275b9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d275b9",
  null
  
)

export default component.exports